import { Route, Routes } from "react-router-dom";
import "./App.css";
import Views from "./views";

function App() {
  return (
    <div className="">
      <Routes>
        <Route path="*" element={<Views />} />
      </Routes>
    </div>
  );
}

export default App;
